var _ReverseComparer_comparer;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
/** reverses the comparer provided */
export default class ReverseComparer {
    constructor(comparer) {
        _ReverseComparer_comparer.set(this, void 0);
        __classPrivateFieldSet(this, _ReverseComparer_comparer, comparer, "f");
    }
    compare(x, y) {
        return __classPrivateFieldGet(this, _ReverseComparer_comparer, "f").compare(y, x);
    }
    equals(x, y) {
        return __classPrivateFieldGet(this, _ReverseComparer_comparer, "f").equals(y, x);
    }
    greaterThan(x, y) {
        return __classPrivateFieldGet(this, _ReverseComparer_comparer, "f").greaterThan(y, x);
    }
    greaterThanOrEqual(x, y) {
        return __classPrivateFieldGet(this, _ReverseComparer_comparer, "f").greaterThanOrEqual(y, x);
    }
    lessThan(x, y) {
        return __classPrivateFieldGet(this, _ReverseComparer_comparer, "f").lessThan(y, x);
    }
    lessThanOrEqual(x, y) {
        return __classPrivateFieldGet(this, _ReverseComparer_comparer, "f").lessThanOrEqual(y, x);
    }
}
_ReverseComparer_comparer = new WeakMap();
